/* Shared class bundles. Keeping them here means the visual language is
   defined once in plain JS, and every component composes from it. */

export const cx = (...parts) => parts.filter(Boolean).join(" ");

export const shell = "px-gutter";
export const inner = "mx-auto max-w-shell";

export const eyebrow =
  "font-sans text-[11px] font-medium uppercase tracking-[0.24em] text-ash-400";

export const display = "font-display font-normal leading-[0.92] tracking-[-0.02em]";

/* Pill buttons. The fill sweeps up from the baseline on hover — one
   gesture reused across the whole page. */
export const btnBase =
  "group/btn relative inline-flex items-center gap-2.5 overflow-hidden rounded-full border border-transparent px-6 py-3.5 text-xs font-medium uppercase tracking-[0.14em] transition-[color,border-color] duration-[400ms] ease-out";

export const btnSweep =
  "pointer-events-none absolute inset-0 z-0 origin-bottom scale-y-0 transition-transform duration-500 ease-smooth group-hover/btn:scale-y-100";

export const btnSolid = "bg-paper text-ink hover:text-paper";
export const btnSolidSweep = "bg-ink-800";

export const btnGhost = "border-white/15 text-paper hover:border-paper hover:text-ink";
export const btnGhostSweep = "bg-paper";

export const btnIcon =
  "relative z-10 transition-transform duration-[400ms] ease-out group-hover/btn:translate-x-[3px] group-hover/btn:-translate-y-[3px]";

export const btnLabel = "relative z-10";

/* Monochrome photography — the site runs on ink and paper only. */
export const photoMono = "grayscale contrast-[1.06]";

export const lineDark = "border-white/15";
export const lineLight = "border-black/10";
